import React from 'react';
import classNames from 'classnames';

import css from './IconQuestion.module.css';

/**
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own root class
 * @param {string?} props.rootClassName overwrite components own root class
 * @returns {JSX.Element}
 */
const IconQuestion = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.6673 7C13.6673 10.6819 10.6825 13.6667 7.00065 13.6667C3.31875 13.6667 0.333984 10.6819 0.333984 7C0.333984 3.3181 3.31875 0.333332 7.00065 0.333332C10.6825 0.333332 13.6673 3.3181 13.6673 7ZM7.00065 4.16667C6.58644 4.16667 6.25065 4.50245 6.25065 4.91667C6.25065 5.19281 6.02679 5.41667 5.75065 5.41667C5.47451 5.41667 5.25065 5.19281 5.25065 4.91667C5.25065 3.95017 6.03415 3.16667 7.00065 3.16667C7.96715 3.16667 8.75065 3.95017 8.75065 4.91667C8.75065 5.39056 8.56163 5.82132 8.25596 6.13597C8.19445 6.19929 8.13577 6.25791 8.0798 6.31384C7.93591 6.4576 7.80985 6.58356 7.69925 6.72566C7.55323 6.91328 7.50065 7.05117 7.50065 7.16667V7.66667C7.50065 7.94281 7.27679 8.16667 7.00065 8.16667C6.72451 8.16667 6.50065 7.94281 6.50065 7.66667V7.16667C6.50065 6.72987 6.70399 6.37629 6.9101 6.11147C7.0626 5.91553 7.25428 5.72423 7.40984 5.56897C7.45676 5.52214 7.5004 5.47859 7.53868 5.43918C7.67037 5.30362 7.75065 5.12003 7.75065 4.91667C7.75065 4.50245 7.41487 4.16667 7.00065 4.16667ZM7.00065 10.3333C7.36884 10.3333 7.66732 10.0349 7.66732 9.66667C7.66732 9.29848 7.36884 9 7.00065 9C6.63246 9 6.33398 9.29848 6.33398 9.66667C6.33398 10.0349 6.63246 10.3333 7.00065 10.3333Z"
        fill="#5BA4EA"
      />
    </svg>
  );
};

export default IconQuestion;
